import '../assets/NcHeaderMenu-zo6kw_jn.css';
import { defineComponent, ref, computed, useTemplateRef, watch, nextTick, createBlock, openBlock, resolveDynamicComponent, normalizeClass, unref, withCtx, createVNode, createElementBlock, createCommentVNode, withDirectives, withModifiers, renderSlot, toDisplayString, createElementVNode, vShow } from "vue";
import { onClickOutside } from "@vueuse/core";
import { createFocusTrap } from "focus-trap";
import "./useFormatDateTime-lk3QDXbQ.mjs";
import { useHotKey } from "../composables/useHotKey/index.mjs";
import "../composables/useIsDarkTheme/index.mjs";
import "../composables/useIsFullscreen/index.mjs";
import "../composables/useIsMobile/index.mjs";
import { g as getTrapStack } from "./focusTrap-DmkaYJTC.mjs";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { N as NcButton } from "./NcButton-Byg8-ta1.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "header-menu__caret" };
const _hoisted_3 = ["id"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcHeaderMenu",
  props: {
    id: {},
    ariaLabel: {},
    open: { type: Boolean, default: false },
    isNav: { type: Boolean, default: false },
    description: {},
    excludeClickOutsideSelectors: { default: () => [] }
  },
  emits: ["closed", "opened", "update:open"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const descriptionId = createElementId();
    const triggerId = createElementId();
    const focusTrap = ref();
    const isOpened = ref(__props.open);
    const wrapperTag = computed(() => __props.isNav ? "nav" : "div");
    const contentContainer = useTemplateRef("contentContainer");
    const headerMenu = useTemplateRef("headerMenu");
    const triggerButton = useTemplateRef("triggerButton");
    const ignore = computed(
      () => Array.isArray(__props.excludeClickOutsideSelectors) ? __props.excludeClickOutsideSelectors : __props.excludeClickOutsideSelectors.split(" ")
    );
    onClickOutside(headerMenu, () => setMenuState(false), { ignore });
    useHotKey("Escape", () => setMenuState(false), { prevent: true });
    watch(() => __props.open, (state) => setMenuState(state));
    function toggleMenu() {
      setMenuState(!isOpened.value);
    }
    async function setMenuState(state) {
      if (state === isOpened.value) {
        return;
      }
      isOpened.value = state;
      emit("update:open", state);
      await nextTick();
      await (state ? addFocusTrap() : clearFocusTrap());
      emit(state ? "opened" : "closed");
    }
    function onFocusOut(event) {
      if (!__props.isNav) {
        return;
      }
      if (!(event.relatedTarget instanceof Node)) {
        return;
      }
      if (headerMenu.value?.contains(event.relatedTarget)) {
        setMenuState(false);
      }
    }
    async function addFocusTrap() {
      if (__props.isNav || focusTrap.value) {
        return;
      }
      focusTrap.value = createFocusTrap(contentContainer.value, {
        allowOutsideClick: true,
        trapStack: getTrapStack(),
        fallbackFocus: triggerButton.value?.$el
      });
      focusTrap.value.activate();
    }
    function clearFocusTrap() {
      focusTrap.value?.deactivate();
      focusTrap.value = void 0;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(wrapperTag.value), {
        id: _ctx.id,
        ref_key: "headerMenu",
        ref: headerMenu,
        "aria-labelledby": _ctx.isNav ? unref(triggerId) : null,
        class: normalizeClass([{ "header-menu--opened": isOpened.value }, "header-menu"]),
        onFocusout: onFocusOut
      }, {
        default: withCtx(() => [
          createVNode(unref(NcButton), {
            id: _ctx.isNav ? unref(triggerId) : null,
            ref_key: "triggerButton",
            ref: triggerButton,
            class: "header-menu__trigger",
            "aria-controls": `header-menu-${_ctx.id}`,
            "aria-expanded": isOpened.value.toString(),
            size: "large",
            variant: "tertiary-no-background",
            onClick: withModifiers(toggleMenu, ["prevent"])
          }, {
            icon: withCtx(() => [
              renderSlot(_ctx.$slots, "trigger", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["id", "aria-controls", "aria-expanded"]),
          _ctx.description ? (openBlock(), createElementBlock("span", {
            key: 0,
            id: unref(descriptionId),
            class: "header-menu__description hidden-visually"
          }, toDisplayString(_ctx.description), 9, _hoisted_1)) : createCommentVNode("", true),
          withDirectives(createElementVNode("div", _hoisted_2, null, 512), [
            [vShow, isOpened.value]
          ]),
          withDirectives(createElementVNode("div", {
            id: `header-menu-${_ctx.id}`,
            class: "header-menu__wrapper"
          }, [
            createElementVNode("div", {
              ref_key: "contentContainer",
              ref: contentContainer,
              class: "header-menu__content"
            }, [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ], 512)
          ], 8, _hoisted_3), [
            [vShow, isOpened.value]
          ])
        ]),
        _: 3
      }, 40, ["id", "aria-labelledby", "class"]);
    };
  }
});
const NcHeaderMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-4113a882"]]);
export {
  NcHeaderMenu as N
};
//# sourceMappingURL=NcHeaderMenu-D-WDQIHd.mjs.map
